__turbopack_context__.v({
  "bannerText": "PurchaseTokensBanner-module__2s8uZq__bannerText",
  "container": "PurchaseTokensBanner-module__2s8uZq__container",
  "icon": "PurchaseTokensBanner-module__2s8uZq__icon",
});
